import { TagCategory } from '@geartracker/types';

import { createZodDto } from './zod';

import { z } from 'zod';

export const CreateUpdateTagSchema = z.object({
  name: z.string().min(1),
  category: z.enum(TagCategory),
});

export class CreateUpdateTagDto extends createZodDto(CreateUpdateTagSchema) {}
